import { SessionSummaryPage } from './SessionSummaryPage';
export default SessionSummaryPage;
